import { ruRU } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';

const themeFormula55 = createTheme(
  {
    palette: {
      mode: 'dark',
      primary: {
        main: '#fee900',
      },
      warning: {
        main: '#fee900',
      },
      secondary: {
        main: '#272727',
      },
      success: {
        main: '#00783f',
      },
      info: {
        main: '#29b6f6',
      },
      white: {
        main: '#fff',
      },
      midnightBlue: {
        main: '#011c40',
        dark: '#021734',
      },
    },
    gradient: {
      allJackpot: {
        main: 'linear-gradient(270deg, #00483b 0, #008625)',
        new: 'linear-gradient(90deg, rgb(53, 54, 58) 0%, rgb(38, 39, 41) 49%, rgb(21, 22, 24) 100%)',
      },
    },
    mixins: {
      toolbar: {
        height: '56px',
      },
    },
    typography: {
      htmlFontSize: 18,
      button: {
        fontWeight: 'bold',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            '&.no-shadow': {
              boxShadow: 'none',
            },
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          color: 'warning',
          variant: 'filled',
        },
      },
      MuiSkeleton: {
        defaultProps: {
          animation: 'wave',
        },
      },
      MuiFilledInput: {
        defaultProps: {
          disableUnderline: true,
        },
        styleOverrides: {
          root: ({ ownerState, theme }) => ({
            ...(ownerState.disableUnderline && {
              borderRadius: theme.shape.borderRadius,
            }),
          }),
          input: ({ ownerState }) => ({
            ...(ownerState.endAdornment && {
              '&:-webkit-autofill': {
                borderBottomLeftRadius: 'inherit',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
              },
            }),
          }),
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            '&.no-shadow': {
              boxShadow: 'none',
            },
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: ({ theme }) => ({
            '&.Mui-selected': {
              color: theme.palette.warning.main,
            },
          }),
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: ({ theme }) => ({
            backgroundColor: theme.palette.warning.main,
          }),
        },
      },
      MuiMenu: {
        styleOverrides: {
          list: {
            '& > .MuiMenuItem-root:last-child': {
              borderBottom: 'none',
            },
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            margin: '8px',
            width: 'calc(100% - 16px)',
            maxHeight: 'calc(100% - 16px)',
            maxWidth: 'calc(100% - 16px)',
          },
          paperWidthSm: {
            width: '600px',
          },
        },
      },
    },
  },
  ruRU,
);

export default themeFormula55;
